import { FC, useState } from 'react';
import { AssetClass } from '@monorepo/types';
import { useDashboard } from '../../../contexts';
import { SupportedSymbolsModal } from '../../supported-symbols-modal';
import {
  DashboardHeaderInfo,
  DashboardHeaderLayout,
  WidgetList,
} from './components';

export const DashboardHeader: FC = () => {
  const { assetType } = useDashboard();
  const [isSymbolsModalOpen, setIsSymbolsModalOpen] = useState(false);

  const isFutures = assetType === AssetClass.Futures;

  const handleOpenSymbolsModal = () => setIsSymbolsModalOpen(true);

  return (
    <>
      <DashboardHeaderLayout>
        <DashboardHeaderInfo
          onOpenSymbolsModal={isFutures ? handleOpenSymbolsModal : undefined}
        />
        <WidgetList />
      </DashboardHeaderLayout>
      {isFutures && (
        <SupportedSymbolsModal
          open={isSymbolsModalOpen}
          onClose={() => setIsSymbolsModalOpen(false)}
        />
      )}
    </>
  );
};
